import React, { useState } from "react";
import { useFormik } from "formik";
import { object, string } from "yup";
import axios from "axios";

import FormInput from "@/components/FormInput";
import Button from "@/components/Button";

import styles from "./index.module.scss";
import { ReactComponent as VerifiedIcon } from "../../bed-configurator/assets/img/icons/verified.svg";

import config from "@/config";
import { emailSchema } from "@/helpers/validation";
import { useSale } from "@/features/bed-configurator/components/Sale";

const { translations } = config;

const FormSchema = object().shape({
	email: emailSchema(string()).required(translations.form.required),
});

const KlaviyoForm = ({ data }) => {
	const [sending, setSending] = useState(false),
		[wasSent, setWasSent] = useState(false),
		{ isSale } = useSale();

	const form = useFormik({
		initialValues: {
			email: "",
		},
		validationSchema: FormSchema,
		validateOnBlur: true,
		validateOnChange: true,
		onSubmit: ({ email }) => {
			setSending(true);
			axios.post(`${window.mozartApp.ajaxUrl}?action=mozart_newsletter_sign_up_with_coupon_codes`, {
				email, ...data,
			}).then((resp) => {
				setWasSent(true);
				form.resetForm();
			})
				.catch(err => alert(err.response.data))
				.finally(() => setSending(false));
		},
	});

	return (
		<div>
			{wasSent === true &&
				<div className={styles.success}>
					<VerifiedIcon />

					<p>
						Du hast
						Deinen Entwurf erfolgreich
						gespeichert. Die E-Mail sollte in wenigen Minuten in Deinem Postfach sein.
					</p>

					{isSale && (
						<p style={{ color: "red" }}>
							Wichtig: Du erhältst gleich eine zweite E-Mail, um Deine Anmeldung zu bestätigen.
							Bitte
							klicke dort auf den
							Bestätigungslink. <strong>Erst dann erhältst Du die Rabattcodes.</strong>
						</p>
					)}

					<p>
						Tipp: bei T-Online Kunden kann es Probleme bei der Zustellung geben, probiere bitte eine
						andere
						E-Mail Adresse.
					</p>

				</div>
			}

			{wasSent === false &&
				<form className={styles.form} onSubmit={form.handleSubmit}>
					<FormInput
						placeholder="Deine E-Mail-Adresse…"
						name="email"
						form={form}
						floatingLabel
					/>

					<Button loader={sending} submit
					        abClassName={`${!isSale ? "Entwurf speichern & 380€ sichern" : "Gutscheine sichern"}`}>
						{!isSale ? "Entwurf speichern & 380€ sichern" : "Gutscheine sichern"}
					</Button>

					<small>Mit Klick auf den Button akzeptierst Du unsere Datenschutzhinweise. </small>
				</form>
			}
		</div>
	);
};

export default KlaviyoForm;
